module.exports = __webpack_public_path__ + "media/images/menu/m8-59939cb07ee996eba9be7566c25ce7f0.JPG";